






import { Component, Prop, Vue } from 'vue-property-decorator'

type widthDescription = 'small' | 'normal' | 'large' | 'larger'

@Component
export default class BuilderDescription extends Vue {
  @Prop({ default: 'none', type: String }) private descWidth!: widthDescription

  get descriptionWidth(): string {
    switch (this.descWidth) {
      case 'normal':
        return 'w-steps-description'
      case 'large':
        return 'w-steps-description-large'
      case 'larger':
        return 'w-steps-description-larger'
      default:
        return 'none'
    }
  }
}
